import { render, staticRenderFns } from "./PackageTypeAutocomplete.vue?vue&type=template&id=66d52f8c&scoped=true"
import script from "./PackageTypeAutocomplete.vue?vue&type=script&lang=js"
export * from "./PackageTypeAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d52f8c",
  null
  
)

export default component.exports